import { useSelector, useDispatch } from 'react-redux';
import { returnToCatalog } from '../../../slices/navigationSlice';
import './CheckoutConfirmation.scss';

export default function CheckoutConfirmation() {
    const dispatch = useDispatch();

    const book = useSelector(
        (state) => state.navigation.selectedBook
    );

    const formatDate = (date) => {
        if (!date) return 'Not available';

        return new Date(date).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        });
    };

    if (!book) {
        return null;
    }

    return (
        <main className="checkout-confirmation">
            <section className="checkout-card">

                <div className="success-icon">✓</div>

                <h1>Checkout Successful!</h1>

                <p className="checkout-message">
                    Your book has been added to My Books.
                </p>

                <div className="book-summary">
                    <img
                        src={book.cover}
                        alt={`${book.bookTitle} cover`}
                        className="book-cover"
                    />

                    <div className="book-info">
                        <h2>{book.bookTitle}</h2>
                        <p>By {book.author}</p>
                        <span>
                            {book.genre} • {book.published}
                        </span>
                    </div>
                </div>

                <div className="due-date">
                    <span className="due-label">Due Date</span>

                    <div className="due-date-value">
                        <span>📅</span>
                        <strong>{formatDate(book.dueDate)}</strong>
                    </div>
                </div>

                <div className="checkout-actions">
                    <button className="primary-button">
                        My Books
                    </button>

                    <button
                        className="secondary-button"
                        onClick={() => dispatch(returnToCatalog())}
                    >
                        Back to Library
                    </button>
                </div>

            </section>
        </main>
    );
}